import { render, staticRenderFns } from "./AnalitycsChart.vue?vue&type=template&id=2f5270a9&scoped=true&"
import script from "./AnalitycsChart.vue?vue&type=script&lang=js&"
export * from "./AnalitycsChart.vue?vue&type=script&lang=js&"
import style0 from "./AnalitycsChart.vue?vue&type=style&index=0&id=2f5270a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5270a9",
  null
  
)

export default component.exports